/*
 * @prettier
 * @copyright (c) 2019 - present, HGC-AB
 * @licence This source code is licensed under the MIT license described and found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'
import PropTypes from 'prop-types'

/**
 * hook that returns a trigger when scroll threshold is met
 */
import { useScrollTrigger } from '@material-ui/core'

/**
 * Elevate children components
 * @param {Object} props - component properties
 * @param {*} props.children - children components
 * @returns {React.ReactSVGElement}
 * @constructor
 */
function ElevationScroll({ children }) {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  })

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0
  })
}

ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired,
}

export default ElevationScroll
